import React, { useCallback } from 'react'
import { SxProps, TextField } from '@mui/material'
import { grayText2 } from '@/constant'
import { isEmpty } from '@/utils'
import { ImageIcon } from '@/icon'
import search_icon from '@/asset/img/search_icon.webp'
import ClearIcon from '@mui/icons-material/Clear'

export interface KeywordSearchProps {
  variant?: 'filled' | 'outlined'
  value: string
  onChange: (value: string) => void
  onSearch: () => void
  clear?: boolean
  onClear?: () => void
  placeholder?: string
  sx?: SxProps
}

export const KeywordSearch: React.FC<KeywordSearchProps> = (props) => {
  const { value, onChange, onSearch, clear, onClear, placeholder, sx, variant = 'filled' } = props

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const input = event?.target?.value ?? ''
      if (!isEmpty(input)) {
        onChange(input?.trim())
      } else {
        onChange('')
      }
    },
    [onChange],
  )

  const onKeyUp = useCallback(
    (event: React.KeyboardEvent) => {
      const key = event?.code
      if (key === 'Enter') {
        event.preventDefault()
        onSearch && onSearch()
      }
    },
    [onSearch],
  )

  const handleClear = useCallback(() => {
    onChange('')
    onClear && onClear()
  }, [onChange, onClear])

  return (
    <TextField
      sx={{ borderRadius: '4px', width: '282px', ...sx }}
      placeholder={placeholder ?? '搜索'}
      size='small'
      variant={variant}
      InputProps={{
        startAdornment: <ImageIcon src={search_icon} sx={{ width: '14px' }} />,
        endAdornment: clear && !isEmpty(value) && (
          <ClearIcon sx={{ cursor: 'pointer' }} fill={grayText2} onClick={handleClear} />
        ),
      }}
      value={value}
      onChange={handleInputChange}
      onKeyUp={onKeyUp}
    />
  )
}
